import React from 'react';
import { getAssetPath } from '../utils/paths';
import './BusinessCard.css';

const BusinessCard = () => {
  return (
    <section id="business-card" className="business-card">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Business Card</h2>
          <p className="section-subtitle">
            Content to be filled in later
          </p>
        </div>

        <div className="business-card-content">
          <div className="business-card-image-section">
            <img 
              src={getAssetPath('Mary Digital Business Card.jpg')}
              alt="Mary K. Carpenter Business Card" 
              className="business-card-image"
              onError={(e) => {
                console.error('Business card image failed to load:', e.target.src);
                // Try absolute path as fallback
                e.target.src = '/Mary Digital Business Card.jpg';
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessCard;


